import React, { useState, useEffect } from 'react';
import { FaPhone, FaShoppingCart, FaBars, FaTimes } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import LeadModal from './LeadModal';
import { useCart } from '../utils/cart';
import { reachGoal } from '../utils/metrika';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const cartCount = useCart().reduce((s, x) => s + (x.qty || 1), 0);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'О производстве', href: '#production' },
    { label: 'Каталог', href: '#catalog' },
    { label: 'Конфигуратор', route: '/configurator' },
    { label: 'Кейсы', route: '/cases' },
    { label: 'Отрасли', href: '#industries' },
    { label: 'Контакты', href: '#contacts' },
  ];

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);

    if (location.pathname !== '/') {
      navigate('/' + href);
      return;
    }

    const element = document.querySelector(href);
    if (element) {
      const headerHeight = document.querySelector('.header').offsetHeight;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - headerHeight,
        behavior: 'smooth'
      });
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="header-left">
          <a href="#hero" className="logo" onClick={(e) => handleNavClick(e, '#hero')}>
            <img src="/logo.png" alt="Орион - производитель электротехнических корпусов" className="logo-img" />
          </a>
        </div>

        <nav className={`site-nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
          {navLinks.map((link, index) => (
            link.route ? (
              <Link
                key={index}
                to={link.route}
                className="site-nav-link"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={index}
                href={link.href}
                className="site-nav-link"
                onClick={(e) => handleNavClick(e, link.href)}
              >
                {link.label}
              </a>
            )
          ))}
          <Link
            to="/cart"
            className="site-nav-link site-nav-cart"
            aria-label={cartCount ? `Корзина, товаров: ${cartCount}` : 'Корзина'}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <FaShoppingCart />
            <span className="site-nav-cart-label">Корзина</span>
            {cartCount > 0 && <span className="site-nav-cart-count">{cartCount}</span>}
          </Link>
          <div className="site-nav-actions">
            <button
              type="button"
              className="header-email-btn"
              onClick={() => { setIsMobileMenuOpen(false); setIsLeadModalOpen(true); }}
            >
              Оставить заявку
            </button>
          </div>
        </nav>

        <div className="header-right">
          <a
            href="tel:+78122373834"
            className="header-phone"
            aria-label="Позвонить: +7 812 237-38-34"
            onClick={() => reachGoal('clc-tel1')}
          >
            <FaPhone /> <span className="header-phone-number">+7 812 237-38-34</span>
          </a>
          <button type="button" className="header-email-btn header-lead-btn" onClick={() => setIsLeadModalOpen(true)}>
            Оставить заявку
          </button>
        </div>

        <button
          className="mobile-menu-btn"
          aria-label={isMobileMenuOpen ? "Закрыть меню" : "Открыть меню"}
          aria-expanded={isMobileMenuOpen}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
      <LeadModal show={isLeadModalOpen} onClose={() => setIsLeadModalOpen(false)} goalId="form-menu" />
    </header>
  );
};

export default Header;
